import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import config from 'ui-ember-vite/config/environment';

export default class ApplicationRoute extends Route {
  @service session;
  @service currentUser;
  @service request;
  @service router;

  _authenticationAttempted = false;

  async beforeModel() {
    await this.session.setup();

    if (!this.session.isAuthenticated && !this._authenticationAttempted) {
      this._authenticationAttempted = true;
      await this._performAutoAuthentication();
    }

    if (this.session.isAuthenticated) {
      await this._loadCurrentUser();
    }
  }

  async _performAutoAuthentication() {
    try {
      let username = this._getHardcodedUsername();
      let password = this._getHardcodedPassword();

      if (!username || !password) {
        console.error('No credentials configured for auto-authentication');
        this.router.transitionTo('unauthorized');
        return;
      }

      let empresas = await this.request.post(
        'consultar_empresas',
        { username, password },
        { anonymous: true },
      );

      if (!empresas || empresas.length === 0) {
        throw new Error('No companies available');
      }

      let empresaSeleccionada = empresas[0].codempresa;
      await this.session.authenticate('authenticator:jwt', {
        username: `${username}@${empresaSeleccionada}`,
        password: password,
      });

    } catch (error) {
      console.error('Error details:', error);

      this._authenticationAttempted = false;
      this.router.transitionTo('unauthorized');
    }
  }

  async _loadCurrentUser() {
    try {
      let user = await this.currentUser.load();

      return user;
    } catch (error) {
      console.error('Error loading current user:', error);

      this.session.invalidate();

      throw error;
    }
  }

  _getHardcodedUsername() {
    return config.AUTO_LOGIN_USERNAME || null;
  }

  _getHardcodedPassword() {
    return config.AUTO_LOGIN_PASSWORD || null;
  }
}